/*
 * @Author: your name
 * @Date: 2020-03-20 10:12:44
 * @LastEditTime: 2020-04-13 11:24:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \cloudpc_omc\src\utils\request.ts
 */
import axios from 'axios';
import { UserModule } from '@/store/modules/user';
import { toast } from './common';
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: 'http://172.16.60.33:10100/',
  timeout: 30000,
});
// Request interceptors
service.interceptors.request.use(
  config => {
    // Add X-Access-Token header to every request, you can add other custom headers here
    if (UserModule.token) {
      config.headers['x-token'] = UserModule.token;
    }
    if (UserModule.activeBrand) {
      config.headers['x-appId'] = UserModule.activeBrand;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// Response interceptors
service.interceptors.response.use(
  response => {
    const { headers, status, data } = response;
    // 针对导出操作
    if (headers['content-type'] === 'text/csv' || headers['content-type'] === 'application/csv;charset=UTF-8') {
      return data;
    }
    if (status >= 200 && status < 400) {
      return data;
    }
    if (status >= 200 && status < 400) {
      if (data.code === 0) {
        return data;
      } else if (!data.code && !data.msg && headers['content-type'] === 'application/octet-stream') {
        return { data: data, code: 0, msg: '' };
      } else {
        toast(data.msg, 'error');
      }
      // return data;
      return Promise.reject(data);
    }
    if (status === 401) {
      toast(data.msg, 'error');
      UserModule.ResetToken();
      return Promise.reject(response);
    }
  },
  error => {
    if (error.response) {
      const { status } = error.response;
      if (status === 401) {
        toast('登录失效，请重新登录', 'error');
        UserModule.ResetToken();
        location.reload();
        return;
      }
    }
    toast('获取数据出错，请确保网络正常', 'error');
    // UserModule.ResetToken(); // 401 被抛出到error里面
    return Promise.reject(error);
  }
);

export default service;
